import React from 'react';

import { Row, Col, Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
//import { HeaderLogo, KeenanLogo } from '../../configuration/ImagesPath';
//import HttpHeader from '../../shared/httpheader';
import PortalName from 'src/Admin/components/header/PortalName';

export default function PublicHeader() {
  const { isLogoLoaded, logoImage, logoType } = useSelector(
    (state) => state.theme,
  );
  return (
    <div className="public-container-offset public-header mr-0 ml-0 d-flex">
      <Container className="px-0">
        <Row className="w-100 h-100 mx-0">
          <Col sm={8} xs={9} className="d-flex px-0">
            <div className="my-auto ">
              {isLogoLoaded && (
                <img
                  src={'data:' + logoType + ';base64, ' + logoImage}
                  alt="Company Logo"
                />
              )}
            </div>
          </Col>

          <Col sm={4} xs={2} className="m-auto px-0">
            <PortalName />
          </Col>
        </Row>
      </Container>
    </div>
  );
}
